import React from 'react'
import { X, Edit, Trash2, Pin, PinOff } from 'lucide-react'
import './StickyNote.css'

const StickyNote = ({ note, onEdit, onDelete, onTogglePin, isOwner }) => {
    const noteStyle = {
        backgroundColor: note.color || '#FFD700',
        borderLeft: `4px solid ${note.color ? adjustBrightness(note.color, -20) : '#FFC700'}`
    }

    return (
        <div className={`sticky-note ${note.pinned ? 'pinned' : ''}`} style={noteStyle}>
            <div className="sticky-note-header">
                {note.pinned && (
                    <div className="pin-indicator">
                        <Pin size={14} />
                    </div>
                )}
                {isOwner && (
                    <div className="sticky-note-actions">
                        <button
                            className="sticky-btn"
                            onClick={() => onTogglePin(note.id, !note.pinned)}
                            title={note.pinned ? 'Desfijar' : 'Fijar'}
                        >
                            {note.pinned ? <PinOff size={14} /> : <Pin size={14} />}
                        </button>
                        <button
                            className="sticky-btn"
                            onClick={() => onEdit(note)}
                            title="Editar"
                        >
                            <Edit size={14} />
                        </button>
                        <button
                            className="sticky-btn delete"
                            onClick={() => onDelete(note.id)}
                            title="Eliminar"
                        >
                            <X size={14} />
                        </button>
                    </div>
                )}
            </div>
            <p className="sticky-note-content">{note.content}</p>
        </div>
    )
}

// Helper function to adjust color brightness
function adjustBrightness(color, amount) {
    const num = parseInt(color.replace('#', ''), 16)
    const r = Math.max(0, Math.min(255, (num >> 16) + amount))
    const g = Math.max(0, Math.min(255, ((num >> 8) & 0x00FF) + amount))
    const b = Math.max(0, Math.min(255, (num & 0x0000FF) + amount))
    return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`
}

export default StickyNote
